
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig } from './form.model';
import { DealerCodeText, defaultSearchContainerButtons, FieldNames, IltPartStartDateDropdown, RegistrationStatusDropdown, SpinIdNumber, VenueAreaDropdown, VenuesDropdown } from './form-fields.model';
import { DataTableSchema, DefaultTableSchema } from './dynamic-data-table.model';
import { FETCH_METHODS, SearchConfig } from './api.model';
import { OptionsFetchConfig } from './common.model';


const FormFieldArray: FormFieldConfig[] = structuredClone([
SpinIdNumber,{ ...structuredClone(DealerCodeText),displayName: 'Dealer'},{ ...structuredClone(VenueAreaDropdown),fieldName:FieldNames['Area'], defaultValue: '', isLoading: true },
{ ...structuredClone(VenuesDropdown), defaultValue: '', isLoading: true },{ ...structuredClone(IltPartStartDateDropdown)}, {...structuredClone(RegistrationStatusDropdown)}]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons).map(btn => ({
    ...btn,
    isDisabled: false,
    customEnableDisable: true,
}));

export const EventReportTitle = "Event Registration Report";

export const EventReportDynamicOptionFields: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['Area'], keyValuePair: { fieldLabel: 'Area', fieldValue: 'area' } },
        { name: FieldNames['RegistrationStatus'], keyValuePair: { fieldLabel: 'Registration Status', fieldValue: 'registrationStatus' } }
    ],
    searchConfig: {
        path: 'eventRegistrationDropdown',
        method: FETCH_METHODS['Get'],
        body: {}
    }
}

export const EventSearchGetConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'eventRegistrationSearch',
    body: {
        "venue": "",
        "iltPartStartDate": "",
    }
}


export const EventReportFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: EventSearchGetConfig,
    alwaysEnableButtons: true,
}


export const EventReportTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "Dealer Code", fieldKey: "dealerCode" },
        { label: "Area", fieldKey: "area" },
        { label: "Last Name", fieldKey: "lastName" },
        { label: "First Name", fieldKey: "firstName" },
        { label: "SPIN ID", fieldKey: "spinId" },
        { label: "Email", fieldKey: "email", isNotCamelCase: true },
        { label: "Job Role", fieldKey: "jobRole" },
        { label: "Dealership Name", fieldKey: "dealershipName" },
        { label: "Distict", fieldKey: "district" },
        { label: "User - Job ID", fieldKey: "jobId" },
        { label: "Event Title", fieldKey: "eventTitle", isNotCamelCase: true },
        { label: "Registration Status", fieldKey: "registrationStatus" },
        { label: "Session City", fieldKey: "sessionCity" },
        { label: "Count Unique Venue", fieldKey: "venue" },
        { label: "Locator Number", fieldKey: "locatorNumber" },
        { label: "Session Start Date", fieldKey: "sessionStartDate" },
        { label: "PC Name", fieldKey: "pcName" },
        { label: "PC Email", fieldKey: "pcEmail", isNotCamelCase: true },
        { label: "Registration Date", fieldKey: "registrationDate" },
        { label: "ILT - Part Start Date", fieldKey: "iltPartStartDate", isCamelCaseHeader: true }    
    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
  exportConfig: {
    fileName: 'Event_Report',
    exportMessage: "Event Registration Data",
    isCamelCase:['area','lastName','firstName'],
    schema: {
        dealerCode: "DEALER CODE",
        area: "AREA",
        lastName: "LAST NAME",
        firstName: "FIRST NAME",
        spinId: "SPIN ID",
        email: "EMAIL",
        jobRole: "JOB ROLE",
        dealershipName: "DEALERSHIP NAME",
        district: "DISTRICT",
        jobId: "USER - JOB ID",
        eventTitle: "EVENT TITLE",
        registrationStatus: "REGISTRATION STATUS",
        sessionCity: "SESSION CITY",
        venue: "COUNT UNIQUE VENUE",
        locatorNumber: "LOCATOR NUMBER",
        sessionStartDate: "SESSION START DATE",
        pcName: "PC NAME",
        pcEmail: "PC EMAIL",
        registrationDate: "REGISTRATION DATE",
        iltPartStartDate: "ILT - PART START DATE",
    }
    },
}